import { FC } from 'react';
import { ResponsibleTabProps } from './ResponsibleTabProps';
import { ESTABLISHMENT_TYPE } from '../ProjectTypeSelect/utils';
import ProjectResponsibleForm from './ProjectResponsibleForm';
import {
  closeProjectResponsibleFields,
  defaultProjectResponsibleFields,
} from './utils';
import ProjectCountryResponsible from '../ProjectCountryResponsible';

const ResponsibleTab: FC<ResponsibleTabProps> = ({ tabType, usersList }) => {
  switch (tabType) {
    case ESTABLISHMENT_TYPE.CLOSE:
      return (
        <>
          <ProjectResponsibleForm
            fields={closeProjectResponsibleFields}
            usersList={usersList}
          />
          <ProjectCountryResponsible usersList={usersList} required={true} />
        </>
      );
    case ESTABLISHMENT_TYPE.IMPROVE:
    case ESTABLISHMENT_TYPE.RELOCATION:
      return (
        <>
          <ProjectResponsibleForm
            fields={defaultProjectResponsibleFields}
            usersList={usersList}
          />
          <ProjectCountryResponsible usersList={usersList} required={true} />
        </>
      );
    case ESTABLISHMENT_TYPE.NEW_UNIT:
    case ESTABLISHMENT_TYPE.FORMAT_CHANGE:
      return (
        <>
          <ProjectResponsibleForm
            fields={defaultProjectResponsibleFields}
            usersList={usersList}
          />
          <ProjectCountryResponsible usersList={usersList} required={true} />
        </>
      );
    default:
      return (
        <ProjectResponsibleForm
          fields={defaultProjectResponsibleFields}
          usersList={usersList}
        />
      );
  }
};

export default ResponsibleTab;
